import { NOTIFICATION_MANAGEMENT } from "../pages/admin/notification/notification.constant";
import { SETTINGS_MANAGEMENT } from "../pages/admin/settings/settings.constant";

export const routeItems = [
  {
    label: "Login",
    route: "/login",
    component: "LoginPage",
    roleLevel: [],
    protected: false,
  },
  {
    label: "ForgetPassword",
    route: "/forget-password",
    component: "ForgetPassword",
    roleLevel: [],
    protected: false,
  },
  {
    label: "RedirectApp",
    route: "/redirect-app/:appId/:token",
    component: "RedirectApp",
    roleLevel: [],
    protected: false,
  },
  {
    label: "Dashboard",
    route: "/",
    component: "HomePage",
    roleLevel: [],
    protected: true,
  },
  {
    label: "Notification",
    route: "/aurlavie/notifications",
    component: "Notification",
    roleLevel: [],
    protected: true,
  },
  {
    label: "Add Notification",
    route: "/aurlavie/notifications/addnotification",
    component: "AddNotification",
    roleLevel: [],
    protected: true,
  },
  {
    label: "Edit Notification",
    route: "/aurlavie/notifications/editNotification/:id",
    component: "EditNotification",
    roleLevel: [],
    protected: true,
  },
  {
    label: "View Notification",
    route: "/aurlavie/notifications/viewNotification/:id",
    component: "ViewNotification",
    roleLevel: [],
    protected: true,
  },
  {
    label: "ResetPassword",
    route: "/reset-password/:id",
    component: "ResetPassword",
    roleLevel: [],
    protected: false,
  },
  {
    label: "User Management",
    route: "/userManagement",
    component: "UserManagement",
    roleLevel: [],
    protected: true,
  },
  {
    label: "Feng Shui Notification",
    route: NOTIFICATION_MANAGEMENT.URL_PATH.FENG_SHUI,
    component: "FengShuiNotification",
    roleLevel: [],
    protected: true,
  },
  {
    label: "Feng Shui Add Notification",
    route: NOTIFICATION_MANAGEMENT.URL_PATH.ADD_NOTIFICATION,
    component: "FengShuiAddNotification",
    roleLevel: [],
    protected: true,
  },
  {
    label: "Feng Shui Edit Notification",
    route: NOTIFICATION_MANAGEMENT.URL_PATH.EDIT_NOTIFICATION,
    component: "FengShuiEditNotification",
    roleLevel: [],
    protected: true,
  },
  {
    label: "Feng Shui View Notification",
    route: NOTIFICATION_MANAGEMENT.URL_PATH.VIEW_NOTIFICATION,
    component: "FengShuiViewNotification",
    roleLevel: [],
    protected: true,
  },
  {
    label: "Feng Shui Setting",
    route: SETTINGS_MANAGEMENT.URL_PATH.FENG_SHUI,
    component: "FengShuiSetting",
    roleLevel: [],
    protected: true,
  },
  {
    label: "Add Category",
    route: "/fengshui/tipsManagement/category/addCategory",
    component: "AddCategory",
    roleLevel: [],
    protected: true,
  },
  {
    label: "Edit Category",
    route: "/fengshui/tipsManagement/category/editCategory/:id",
    component: "EditCategory",
    roleLevel: [],
    protected: true,
  },
  {
    label: "view Category",
    route: "/fengshui/tipsManagement/category/viewCategory/:id",
    component: "ViewCategory",
    roleLevel: [],
    protected: true,
  },
  {
    label: "Tips Management",
    route: "/fengshui/tipsManagement/:type",
    component: "CategoryAndTipsSwitchManagement",
    roleLevel: [],
    protected: true,
  },
  {
    label: "Add Tips",
    route: "/fengshui/tipsManagement/tips/addTips",
    component: "AddTips",
    roleLevel: [],
    protected: true,
  },
  {
    label: "Edit Tips",
    route: "/fengshui/tipsManagement/tips/editTips/:id",
    component: "EditTips",
    roleLevel: [],
    protected: true,
  },
  {
    label: "View Tips",
    route: "/fengshui/tipsManagement/tips/viewTips/:id",
    component: "ViewTips",
    roleLevel: [],
    protected: true,
  },
  {
    label: "Add User",
    route: "/userManagement/addUser",
    component: "AddUser",
    roleLevel: [],
    protected: true,
  },
  {
    label: "View User",
    route: "/userManagement/viewUser",
    component: "ViewUser",
    roleLevel: [],
    protected: true,
  },
  {
    label: "View User",
    route: "/userManagement/viewUser/property/:id",
    component: "UserPropertyDetail",
    roleLevel: [],
    protected: true,
  },
  {
    label: "View User",
    route: "/userManagement/viewUser/resident/:id",
    component: "UserResidentDetail",
    roleLevel: [],
    protected: true,
  },
  {
    label: "Edit User",
    route: "/userManagement/editUser/:id",
    component: "EditUser",
    roleLevel: [],
    protected: true,
  },
  {
    label: "Books Management",
    route: "/aurlavie/booksManagement",
    component: "BooksManagement",
    roleLevel: [],
    protected: true,
  },
  {
    label: "Add Books",
    route: "/aurlavie/booksManagement/addBook",
    component: "AddBooks",
    roleLevel: [],
    protected: true,
  },
  {
    label: "Edit Books",
    route: "/aurlavie/booksManagement/editBook/:id",
    component: "EditBooks",
    roleLevel: [],
    protected: true,
  },
  {
    label: "View Book Section",
    route: "/aurlavie/booksManagement/viewBookSection/:id",
    component: "ViewBookSection",
    roleLevel: [],
    protected: true,
  },
  {
    label: "Edit Book Section",
    route: "/aurlavie/booksManagement/editBookSection/:id",
    component: "EditBookSection",
    roleLevel: [],
    protected: true,
  },
  {
    label: "Add Book Section",
    route: "/aurlavie/booksManagement/addBookSection",
    component: "AddBookSection",
    roleLevel: [],
    protected: true,
  },
  {
    label: "Settings",
    route: "/aurlavie/settings",
    component: "Settings",
    roleLevel: [],
    protected: true,
  },
  {
    label: "Privacy Policy",
    route: "/aurlavie/settings/privacyPolicy",
    component: "Privacy Policy",
    roleLevel: [],
    protected: true,
  },
  {
    label: "Terms Of Service",
    route: "/aurlavie/settings/termsOfService",
    component: "Terms Of Service",
    roleLevel: [],
    protected: true,
  },
  {
    label: "About",
    route: "/aurlavie/settings/about",
    component: "About",
    roleLevel: [],
    protected: true,
  },
  {
    label: "Get Help",
    route: "/aurlavie/settings/getHelp",
    component: "Get Help",
    roleLevel: [],
    protected: true,
  },
  {
    label: "SubAdmin",
    route: "/subAdmin",
    component: "SubAdminUserRoles",
    roleLevel: [],
    protected: true,
  },
  {
    label: "UserRoles",
    route: "/userRoles",
    component: "UserRoles",
    roleLevel: [],
    protected: true,
  },
  {
    label: "Advice Management",
    route: "/aurlavie/adviceManagement",
    component: "AdviceManagement",
    roleLevel: [],
    protected: true,
  },
  {
    label: "Activity Cards",
    route: "/aurlavie/adviceManagement/activityCards/:id",
    component: "ActivityCards",
    roleLevel: [],
    protected: true,
  },
  {
    label: "View Activity Cards",
    route: "/aurlavie/adviceManagement/activityCards/view/:id/:parentAdviceBool?",
    component: "ViewActivityCards",
    roleLevel: [],
    protected: true,
  },
  {
    label: "Edit Activity Cards",
    route: "/aurlavie/adviceManagement/activityCards/edit/:id",
    component: "EditActivityCards",
    roleLevel: [],
    protected: true,
  },
  {
    label: "Content Management",
    route: "/aurlavie/adviceManagement/contentManagement/:id",
    component: "ContentManagement",
    roleLevel: [],
    protected: true,
  },
  {
    label: "View Content Id Data",
    route: "/aurlavie/adviceManagement/content/view/:id",
    component: "ViewContentData",
    roleLevel: [],
    protected: true,
  },
  {
    label: "Edit Content Id Data",
    route: "/aurlavie/adviceManagement/content/edit/:id",
    component: "EditContentData",
    roleLevel: [],
    protected: true,
  },
  {
    label: "Add Content Id Data",
    route: "/aurlavie/adviceManagement/content/add",
    component: "AddContentData",
    roleLevel: [],
    protected: true,
  },
  {
    label: "Add Edit SubAdmin",
    route: "/subAdmin/addSubAdmin",
    component: "AddEditSubAdmin",
    roleLevel: [],
    protected: true,
  },
  {
    label: "Add Edit SubAdmin",
    route: "/subAdmin/editSubAdmin/:id",
    component: "AddEditSubAdmin",
    roleLevel: [],
    protected: true,
  },
  {
    label: "View SubAdmin",
    route: "/subAdmin/viewSubAdmin/:id",
    component: "ViewSubAdmin",
    roleLevel: [],
    protected: true,
  },
  {
    label: "Reports",
    route: "/fengshui/reportsManagement",
    component: "Reports",
    roleLevel: [],
    protected: true,
  },
  {
    label: "Profile Management",
    route: "/profileManagement",
    component: "ProfileManagement",
    roleLevel: [],
    protected: true,
  },
  {
    label: "View Content Id",
    route: "/fengshui/reportsManagement/viewContentId/:type/:id",
    component: "ViewContentId",
    roleLevel: [],
    protected: true,
  },
  {
    label: "Edit Content Id",
    route: "/fengshui/reportsManagement/editContentId/:type/:id",
    component: "EditContentId",
    roleLevel: [],
    protected: true,
  },
  {
    label: "Edit Profile Management",
    route: "/profileManagement/edit",
    component: "EditProfileManagement",
    roleLevel: [],
    protected: true,
  },
  {
    label: "Landing Screen",
    route: "/home",
    component: "LandingScreen",
    roleLevel: [],
    protected: true,
  },
];
